import React, { useState } from 'react';

const ROCAnnualFiling = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with ROC Annual Filing.',
    website_hp: ''
  });

 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with ROC Annual Filing.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              ROC Annual Filing
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              Comprehensive Registrar of Companies (ROC) annual filing services for companies and LLPs. We ensure timely filing of annual returns, financial statements, and compliance forms to maintain your corporate entity's active status and avoid penalties.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">🛡️</span> Maintain Corporate Compliance
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Filing Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of ROC Annual Filing
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                ROC Annual Filing is a mandatory compliance requirement for all companies and LLPs registered in India. It involves filing annual returns and financial statements with the Registrar of Companies to maintain legal status and ensure transparency.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our comprehensive ROC filing service covers all required forms including MGT-7 (Annual Return), AOC-4 (Financial Statements), and LLP Form 11 & 8 for LLPs. We ensure timely filing before due dates to keep your entity compliant.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                With expert knowledge of Companies Act, 2013 and LLP Act, 2008, we handle the entire annual compliance process from document preparation to MCA portal filing.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Statutory Compliance:</strong> Ensure full compliance with Companies Act, 2013 and LLP Act, 2008 requirements.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Timely Filing:</strong> All annual forms filed before due dates (AOC-4: 30 days, MGT-7: 60 days from AGM) to avoid penalties.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Active Status Maintenance:</strong> Keep your company/LLP in 'Active' status and avoid being marked 'Dormant' or 'Struck Off'.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Director Compliance:</strong> Ensure directors remain in compliance and avoid disqualification under Section 164(2).
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">MCA Portal Expertise:</strong> Expert handling of MCA21 portal for all e-filings and compliance requirements.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Financial Statement Preparation:</strong> Assistance in preparing audited financial statements as per Schedule III.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Notice Handling:</strong> Expert assistance in responding to ROC notices, defect memos, and compliance requirements.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with ROC Annual Filing." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for ROC Annual Filing
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "📁", title: "Document Collection", desc: "Collect audited financial statements, annual return details, director reports, and other compliance documents." },
              { number: "02", icon: "✅", title: "Financial Statement Review", desc: "Review audited financial statements for compliance with Schedule III and accounting standards." },
              { number: "03", icon: "👥", title: "Director & Shareholder Details", desc: "Compile director details, shareholding pattern, and changes during the financial year." },
              { number: "04", icon: "📄", title: "Form AOC-4 Preparation", desc: "Prepare Form AOC-4 for filing financial statements and board reports with ROC." },
              { number: "05", icon: "📋", title: "Form MGT-7 Preparation", desc: "Prepare Form MGT-7 (Annual Return) with company details, share capital, and compliance information." },
              { number: "06", icon: "💳", title: "Fee Calculation & Payment", desc: "Calculate ROC filing fees based on authorized capital and process payment through MCA portal." },
              { number: "07", icon: "📤", title: "MCA Portal Filing", desc: "File AOC-4 and MGT-7 forms on MCA21 portal with digital signature of director/CS." },
              { number: "08", icon: "🏆", title: "Filing Confirmation", desc: "Provide SRN numbers, filing acknowledgements, and compliance certificate for records." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Documents Required for ROC Filing
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Essential Documents for Annual Compliance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "📄", title: "Audited Financial Statements", desc: "Balance Sheet, Profit & Loss Account, and cash flow statement duly audited." },
              { icon: "📋", title: "Board Report & Minutes", desc: "Board of Directors report and AGM minutes approving financial statements." },
              { icon: "👥", title: "Director Details", desc: "Director DIN, PAN, and details of appointments/resignations during the year." },
              { icon: "📊", title: "Shareholding Pattern", desc: "Current shareholding pattern and changes in share capital during the year." },
              { icon: "🔑", title: "Digital Signatures", desc: "DSC of director and company secretary for MCA portal filing." },
              { icon: "🏠", title: "Registered Office Proof", desc: "Proof of registered office address and details of any changes." },
              { icon: "👨‍💼", title: "Auditor Details", desc: "Auditor's report and details of auditor appointment/rotation." },
              { icon: "✅", title: "Previous Year Filings", desc: "Copy of last year's ROC filings for reference and continuity." },
              { icon: "💰", title: "Fee Payment Details", desc: "Company bank account details for ROC fee payment processing." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "✅", title: "Filed ROC Forms", desc: "AOC-4 and MGT-7 filing acknowledgements with SRN numbers from MCA portal." },
              { icon: "🛡️", title: "Compliance Certificate", desc: "Annual compliance certificate confirming ROC filing completion and active status." },
              { icon: "📋", title: "Director Compliance Report", desc: "Report confirming director compliance status and avoidance of disqualification." },
              { icon: "📅", title: "Annual Compliance Calendar", desc: "Complete compliance calendar with all upcoming ROC and corporate filing deadlines." },
              { icon: "🎧", title: "Ongoing Compliance Support", desc: "ROC notice handling, compliance monitoring, director KYC support, event-based filing assistance" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      ROC Annual Filing FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "What are the due dates for ROC annual filing?", 
                    answer: "Form AOC-4: Within 30 days of AGM. Form MGT-7: Within 60 days of AGM. For companies without AGM: By September 30th." 
                  },
                  { 
                    question: "What are the penalties for late ROC filing?", 
                    answer: "Additional fees of ₹100 per day for each form, plus normal filing fees. Directors may face disqualification for continuous default." 
                  },
                  { 
                    question: "Which companies require mandatory audit?", 
                    answer: "All companies except One Person Companies with turnover below ₹2 crore and professional service companies below ₹50 lakh." 
                  },
                  { 
                    question: "What is Director KYC and when is it due?", 
                    answer: "Director KYC (DIR-3 KYC) is due annually by September 30th for all directors with active DIN." 
                  },
                  { 
                    question: "Can we file ROC returns after the due date?", 
                    answer: "Yes, but with additional fees. For very late filings, company may need to apply for Condonation of Delay." 
                  },
                  { 
                    question: "What happens if ROC filings are not done?", 
                    answer: "Company may be marked 'Dormant' or 'Struck Off', directors may be disqualified, and bank accounts may be frozen." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for ROC Compliance?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of corporate compliance experts handle your annual ROC filings and maintain your company's active status.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our ROC Compliance Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default ROCAnnualFiling;